// @flow
import styled from 'styled-components';

// Header Simple Elements
export const Header1 = styled.h1`
  font-size: 1.5rem;
  margin: 0;
`;
export const Form = styled.form`
  margin-top: 0.3em;
`;
export const Fieldset = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0 0 0 1.5em;
  display: inline-block;
  &:first-child {
    margin-left: 0;
  }
`;
export const Button = styled.button``;
export const Label = styled.label`
  display: block;
`;
export const Input = styled.input``;
export const Select = styled.select``;



// WEBPACK FOOTER //
// ./src/styles/headerElements.js